import { useAccountContext } from 'application/providers/AccountProvider';

import useCompanyCreateAmoTaskToBill from 'domain/billing/useCompanyCreateAmoTaskToBill';

import { UseInvoiceRequestViewModel } from './types';

const useInvoiceRequestPresenter = (): UseInvoiceRequestViewModel => {
  const { currentCompany } = useAccountContext();

  const { request: companyCreateAmoTaskToBill, loading } = useCompanyCreateAmoTaskToBill();

  const paymentByInvoiceRequest = async () => {
    const isOk = await companyCreateAmoTaskToBill(currentCompany!.id);

    return isOk;
  };

  return {
    isPaymentByInvoiceRequested: Boolean(currentCompany?.isPaymentByInvoiceRequested),
    isPaymentRequestLoading: loading,
    paymentByInvoiceRequest,
  };
};

export default useInvoiceRequestPresenter;
